"use strict";
exports.__esModule = true;
exports.useIsDesktop = void 0;
var react_1 = require("react");
/**
 * @param {number} breakpoint - The breakpoint to check against.
 * @returns True if the screen width is greater than the breakpoint.
 *
 */
var useIsDesktop = function (breakpoint) {
    var isDesktopScreen = function () {
        return typeof window !== "undefined" && window.innerWidth > breakpoint;
    };
    var _a = (0, react_1.useState)(isDesktopScreen()), isDesktop = _a[0], setIsDesktop = _a[1];
    var handleResize = function () {
        setIsDesktop(isDesktopScreen());
    };
    (0, react_1.useEffect)(function () {
        window.addEventListener("resize", handleResize);
        return function () {
            window.removeEventListener("resize", handleResize);
        };
    });
    return isDesktop;
};
exports.useIsDesktop = useIsDesktop;
